import script from "./BrandedNoteElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedNoteElementProduction.vue?vue&type=script&lang=js"
export * from "./BrandedNoteElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedNoteElementProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/BrandedNoteElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e836a638"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e836a638', __exports__)) {
    api.reload('e836a638', __exports__)
  }
  
}


export default __exports__